/* eslint-disable @typescript-eslint/no-explicit-any */
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getNestedValue(obj: any, path: string): any {
  return path.split(".").reduce((acc, key) => {
    if (acc === undefined || acc === null) return undefined;
    // handle array indices
    if (!isNaN(Number(key))) {
      return acc[Number(key)];
    }
    return acc[key];
  }, obj);
}


export const setNestedError = (errors: any, fieldPath: string, message: string) => {
  const keys = fieldPath.split(".");
  let current = errors;

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      current[key] = message;
    } else {
      if (!current[key]) current[key] = {};
      current = current[key];
    }
  });
};